module.exports = __webpack_public_path__ + "static/media/headshot_placeholder.9cd963f3.png";